const semanticClassNames = {
  root: 'footer',
} as const;

export default semanticClassNames;
